/**
 * KpiCard — small stat card with icon, value, and label.
 *
 * Extracted from PurchasesBuilder and UsersBuilder where it was
 * identically duplicated.
 */
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

interface KpiCardProps {
  label: string;
  value: string | null;
  icon: React.ReactNode;
  color: string;
  loading: boolean;
}

export function KpiCard({ label, value, icon, color, loading }: KpiCardProps) {
  return (
    <Card padding="sm" className="flex items-center gap-3">
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
        style={{ background: `${color}15`, color }}
      >
        {icon}
      </div>
      <div className="min-w-0">
        {loading ? (
          <Skeleton className="h-5 w-12 mb-1" />
        ) : (
          <p className="text-base font-bold text-slate-900 truncate">{value ?? '-'}</p>
        )}
        <p className="text-2xs text-slate-500 truncate">{label}</p>
      </div>
    </Card>
  );
}
